import React from "react";

import { ReactComponent as ChevronDownIcon } from "../../Resources/Images/chevron-down.svg";
import "./FlyoutScrollHint.css";

/**
 * Pista visual de que un panel flotante tiene más elementos hacia abajo. Se monta como
 * último hijo del panel y se queda pegada a su borde inferior, sobre el último elemento
 * visible. El icono se inyecta en línea (no como <img>) para que herede el color del
 * texto del panel vía currentColor.
 */
const FlyoutScrollHint = () => (
  <div className="FlyoutScrollHint" aria-hidden="true">
    <span className="FlyoutScrollHintIcon">
      <ChevronDownIcon focusable="false" />
    </span>
  </div>
);

export default FlyoutScrollHint;
